var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconmonstrSitemap7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sitemap-7-icon",
    d: "M397,342h-30c0-79.881-73.919-32.394-111-98.959C219.126,309.234,145,262.43,145,342h-30 c0-133.331,126-28.985,126-172h30C271,313.109,397,208.488,397,342z M326,50H186v100h140V50z M60,362h140v100H60V362z M452,362v100 H312V362H452z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrSitemap7Icon);
export default __webpack_public_path__ + "static/media/iconmonstr-sitemap-7-icon.4250a05f831b96f720aba06c02dee3ea.svg";
export { ForwardRef as ReactComponent };